import { getFormattedZipCode } from "lib/data/formatters/cep";
import { getFormFromLocalStorage, saveFieldsOnLocalStorage } from "pages/home/utils";
import { IStep2FormValues } from "./iStep2FormValues";
import { isValidCep } from "utils";
import { useFormik } from "formik";
import { useState } from "react";
import { validations } from "./validations";
import useZipCodeComplement from "hooks/useZipCodeComplement";

export interface UseStep2FormProps {
  onSubmit: (values: IStep2FormValues) => void;
}

export function useStep2Form(props: UseStep2FormProps) {
  const formFromLocalStorage = getFormFromLocalStorage();
  const form = useFormik<IStep2FormValues>({
    initialValues: {
      company: formFromLocalStorage?.company || "",
      employeesNumber: formFromLocalStorage?.employeesNumber || "",
      whereMeetCaju: formFromLocalStorage?.whereMeetCaju || "",
      cep: formFromLocalStorage?.cep || "",
      uf: formFromLocalStorage?.uf || "",
      website: formFromLocalStorage?.website || "",
      linkedin: formFromLocalStorage?.linkedin || "",
      expectedLeadId: formFromLocalStorage?.expectedLeadId || "",
    },
    validationSchema: validations,
    onSubmit: props.onSubmit,
  });

  const { getComplement, loading } = useZipCodeComplement();
  const [isUfDisabled, setIsUfDisabled] = useState(!!form.values.cep);

  async function setUfField(cep: string) {
    try {
      const complement = await getComplement(cep)
      
      await form.setValues({
        ...form.values,
        uf: complement?.uf || '',
        cep: cep,
      })

      saveFieldsOnLocalStorage(form.values);
      
      setIsUfDisabled(true)
    } catch (error) {
      await form.setFieldTouched('cep', true)
      form.setFieldError('cep', 'CEP não encontrado. Por favor, verifique o número.')
    }
  }

  async function handleCepChange(event: React.ChangeEvent<HTMLInputElement>) {
    setIsUfDisabled(false)
    const cep = getFormattedZipCode(event.currentTarget.value)
    
    await form.setFieldValue('cep', cep)

    if (isValidCep(cep)) await setUfField(cep)
  }

  return {
    ...form,
    handleCepChange,
    isComplementLoading: loading,
    isUfDisabled,
  };
}
